<template>
  <splitpanes class="default-theme" style="background-color: whitesmoke">
    <pane min-size="40" size="60">
      <div class="my-box" >
        <el-row :gutter="5" style="margin-bottom: 3px">
          <el-col :span="24">
            <el-input style="width: 150px" v-model="formData.code" placeholder="程序编码" disabled></el-input>
            <el-input style="width: 150px" v-model="formData.name" placeholder="程序名称" ></el-input>
            <el-cascader style="width: 150px" v-model="formData.dir_id" placeholder="请选择目录" :options="programDirList" :show-all-levels="false"
                         :props="cascaderProps" clearable >
            </el-cascader>
            <el-input style="width: 150px" v-model="formData.remark" placeholder="程序备注" ></el-input>
            <el-input style="width: 150px" v-model="formData.reason" placeholder="编辑理由" ></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="5" style="margin-bottom: 3px">
          <el-col :span="24">
            <el-button  @click="saveProgram">保存</el-button>
            <el-button  @click="activeProgram">升版</el-button>
            <el-button  @click="activeProgram">发放</el-button>
            <el-button  @click="disableProgram">废弃</el-button>
            <el-button  @click="deleteProgram">删除</el-button>
          </el-col>
        </el-row>

        <KfJavaEditor style="width: 100%;height: 100%;margin-top: 2px;margin-bottom: 5px" v-model="formData.content" :placeholder="content_placeholder"></KfJavaEditor>
      </div>
    </pane>

    <pane min-size="30" style="background-color:white">
      <el-tabs v-model="activeName" class="demo-tabs" >
        <el-tab-pane label="调试" name="debug">
          <FrameJavaDebug ref="javaDebug" width="100%" height="100%" style="background-color:white;min-height:800px" :parent-data="formData" ></FrameJavaDebug>
        </el-tab-pane>
        <el-tab-pane label="编码手册" name="help">
          <KfJavaEditor style="width: 100%;height: 100%;min-height:700px; margin-top: 2px;margin-bottom: 5px" v-model="content_help" :placeholder="content_placeholder" read-only></KfJavaEditor>
        </el-tab-pane>
        <el-tab-pane label="AI助手" name="ai">
          <div class="right-container" style="height: 100%;background-color:white">
            <div ref="msgList" class="msg-list">
              <div v-if="msgList.length==0" class="empty-tip">AI编码助手</div>
              <div class="msg-item" v-for="item in msgList">
                <div class="icon">
                  <el-icon :size="32" v-if="item.role=='assistant'">
                    <ElIconCpu/>
                  </el-icon>
                </div>
                <div class="content-box" :class="item.role">
                  <div v-if="item.role=='assistant'" style="display: flex;justify-content: space-between;color: rgb(60, 60, 67, 60%)">
                    <div>
                      <span style="margin-right: 30px;">内容由 AI 生成</span>
                      <el-button link type="primary" @click="copy(item.content)">复制</el-button>
                      <el-button link type="primary" @click="apply(item.content)">应用</el-button>
                    </div>
                    <div>{{ item.create_user_name }} {{ item.create_time }}</div>

                  </div>
                  <div class="content">{{ item.content }}</div>
                </div>
                <div class="icon">
                  <el-icon :size="32" v-if="item.role=='user'">
                    <ElIconUser/>
                  </el-icon>
                </div>
              </div>
            </div>
            <div class="send-box">
              <el-input v-model="question" autosize placeholder="请输入问题，按Enter发送，按Ctrl+Enter" type="textarea" @keydown="handleKeyDown"></el-input>
              <el-button @click="sendMsg" round style="margin-left: 4px">发送</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </pane>
  </splitpanes>
</template>

<script>
import EventSource from 'eventsource';
import {nanoid} from "nanoid";
import FrameJavaDebug from "./FrameJavaDebug.vue";
import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

export default {
  name: "FrameJavaEditor",
  components: {Splitpanes, Pane, FrameJavaDebug},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        id: this.parentData.id,
        code: this.parentData.code,
        name: this.parentData.name,
        content: this.parentData.content,
        dir_id: this.parentData.dir_id,
        remark: this.parentData.remark
      },
      is_edit_mode: false,
      question: '',
      msgList: [],
      activeName: 'debug',
      content_help:'',
      content_placeholder:'/* java代码,实现FrameBean接口;不需要定义package；常用类import不需要写 */',
      programDirList:[],
      cascaderProps: {
        emitPath:false,
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      },
    }
  },
  mounted() {
    this.getDirTree()
    this.loadInfo()
    this.initContentHelp();

  },
  methods: {
    //获取行业类型
    async getDirTree() {
      this.programDirList = await this.$http('sysDirService.getTree', {'dir_def_id': 'sys_program'})
    },
    async loadInfo() {
      this.formData = await this.$http('sysProgramService.getById', {'id': this.parentData.id})
    },
    async saveProgram() {

      if (!this.formData.code) {
        this.$message.error('程序编码为空')
        return;
      }

      if (!this.formData.name) {
        this.$message.error('程序名称为空')
        return;
      }

      if (!this.formData.content) {
        this.$message.error('程序内容为空')
        return;
      }

      //保存
      var rtnData = await this.$http('sysProgramService.edit', this.formData);

      if("success" == rtnData){
        this.$message.success('保存且编译成功');
      }else{
        this.$message.error('代码已保存，但存在问题：' + rtnData)
      }

    },
    async delProgram() {

      this.$confirm('你确定要删除【' + this.parentData.code + '】吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http('sysSchemaService.del', this.parentData);
        this.$message.success('删除成功，本窗口即将关闭')

        //需要关闭当前窗口
      });
    },
    async loadFromDb() {
      let schemaInfo = await this.$http('sysSchemaService.loadSchema', this.parentData);

      this.formData = schemaInfo.schema;
      this.msgList = schemaInfo.historyList;
      this.is_content_changed = false;

    },
    initContentHelp(){
      this.content_help = 'JavaBean编辑器使用说明\n\r';
      this.content_help += '1：类名只能是小写字母、数字、下划线的组合，且不能以数字开头\n';
      this.content_help += '2：类名在整个系统中必须唯一\n';
      this.content_help += '3：在线定义的类，必须实现com.joysun.frame.dto.FrameBean接口\n';
      this.content_help += '4：FrameBean接口只有一个方法public Object execute(BusObject params)\n';
      this.content_help += '5：在线定义的类, 在编译时会自动在最前面加上以下代码, 所以不要重复引入\n';
      this.content_help += '    package com.joysun.frame.service.extend;\n';
      this.content_help += '    import com.joysun.frame.dto.*;\n';
      this.content_help += '    import com.joysun.frame.service.*;\n';
      this.content_help += '    import com.joysun.sys.service.*;\n';
      this.content_help += '    import com.joysun.frame.util.*;\n';
      this.content_help += '    import lombok.extern.slf4j.Slf4j;\n';
      this.content_help += '    import org.springframework.stereotype.Service;\n';
      this.content_help += '6：可以在右侧通过AI生成或修改代码\n';
      this.content_help += '7：保存时会自动编译，且编译后的类即时生效\n';
      this.content_help += '8：编译成功后，可以在调试模式中运行\n';
      this.content_help += '9：推荐使用BusObject和BusQuery进行对象的增删改查操作，示例：\n';
      this.content_help += '    BusObject.newInstance("sys_user").setId("Test001").setField("user_name", "张三").insert();\n';
      this.content_help += '    BusList busList = BusQuery.newInstance("sys_user").selectListByField("status", "active");\n';
      this.content_help += '    busList.setField("status", "disable").update("status");\n';
      this.content_help += '10：可以使用FrameBeanService.execute(beanName, busObject)调用其他JavaBean，注意bean的调用不要死循环\n';
      this.content_help += '11：可以使用@UseCache、@Transactional、@IsolatedTransactional、@Role等注解\n';
      this.content_help += '98：使用Ctrl+Z回退(Undo)代码\n';
      this.content_help += '99：使用Ctrl+Y重做(Redo)代码\n';
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
}


.my-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 2px;
}



.right-container {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;

  .empty-tip {
    font-size: 24px;
    color: #ccc;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}

.send-box {
  display: flex;
  padding: 20px 20px 0 20px;
}

.msg-list {
  flex: 1;
  overflow: auto;

  .msg-item {
    display: flex;
    padding: 20px 20px 0 20px;

    .icon {
      width: 50px;
      text-align: center;
    }

    .content-box {
      flex: 1;
      white-space: pre-wrap;
      border-bottom: 1px dashed #ccc;
      padding-bottom: 20px;
    }

    .content-box .content {
      border-radius: 15px;
      padding: 10px;
    }

    .content-box.user {
      display: flex;
      justify-content: flex-end;
    }

    .content-box.user .content {
      background-color: AliceBlue;
    }

    .content-box.assistant {

    }

    .content-box.assistant .content {
      background-color: #F4F4F4;
    }

  }

  .msg-item:last-child .content-box {
    border-bottom: none;
  }

  .my-sidebar {
    width: 40px; /* 设置工具条的宽度 */
    background-color: #fff; /* 背景颜色 */
    display: flex;
    flex-direction: column; /* 垂直排列图标 */
    align-items: center; /* 水平居中 */
    justify-content: center; /* 垂直居中 */
    border-right: solid 1px #ccc;
  }

  .sidebar-icon {
    margin-bottom: 5px; /* 图标之间的间距 */
  }

  .right-main {
    flex-grow: 1; /* 主区域占满剩余空间 */
    background-color: #e5e5e5; /* 背景颜色 */
  }

  .my-icon-active{
    color: #87CEFA;
  }

  .blue-icon{
    color: blue;
  }
}

</style>